import React from 'react';
import { useTheme } from '../hooks/useTheme';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import { Card } from 'primereact/card';
import { Badge } from 'primereact/badge';
import { Button } from 'primereact/button';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Divider } from 'primereact/divider';
import { Panel } from 'primereact/panel';
// next/image removido para compatibilidad con React
import EnviosAccordion from '../components/landing/EnviosAccordion';

// Metadata de Next.js removida; usar Helmet en caso se requiera SEO dinámico

export default function EnviosYEntregas() {
    const { theme, toggleTheme } = useTheme();

    const deliveryZones = [
        {
            zone: 'Lima Metropolitana',
            time: '1 a 3 días hábiles',
            icon: 'pi pi-building',
            severity: 'success'
        },
        {
            zone: 'Ciudades principales',
            time: '2 a 5 días hábiles',
            icon: 'pi pi-map-marker',
            severity: 'warning'
        },
        {
            zone: 'Zonas alejadas o rurales',
            time: '5 a 10 días hábiles',
            icon: 'pi pi-globe',
            severity: 'danger'
        }
    ];

    const shippingFeatures = [
        {
            title: 'A nivel nacional',
            description: 'Llegamos a todas las regiones del Perú, incluyendo zonas urbanas y rurales',
            icon: 'pi pi-map'
        },
        {
            title: 'Socios logísticos',
            description: 'Trabajamos con empresas de transporte reconocidas para garantizar la seguridad de cada pedido',
            icon: 'pi pi-shield'
        },
        {
            title: 'Entrega flexible',
            description: 'Entrega a domicilio o recojo en agencia. Tú eliges la forma más conveniente de recibir tu compra',
            icon: 'pi pi-calendar'
        }
    ];

    const shippingCosts = [
        {
            title: 'Envío estándar',
            description: 'Tarifas planas según la región',
            icon: 'pi pi-truck'
        },
        {
            title: 'Envío gratuito',
            description: 'Para compras superiores a cierto monto o en campañas especiales',
            icon: 'pi pi-gift'
        },
        {
            title: 'Envíos express',
            description: 'Disponibles en determinadas ciudades con costo adicional',
            icon: 'pi pi-bolt'
        }
    ];

    return (
        <div className={'landing-page theme-' + theme}>
            <Header theme={theme} onToggleTheme={toggleTheme} />

            <div className="surface-ground min-h-screen">
                {/* Hero Section */}
                <div className="surface-section py-3 lg:py-4">
                    <div className=" mx-auto px-4">
                        <div className="grid">
                            <div className="col-12 lg:col-8">
                                <h1 className="text-6xl lg:text-8xl font-bold text-900 mb-4 line-height-2">
                                    Envíos y Entregas
                                </h1>
                                <p className="text-xl lg:text-2xl text-700 line-height-3 mb-3">
                                    En Laptops.pe, nos aseguramos de que tu compra llegue a tus manos de manera segura, rápida y confiable. 
                                    Queremos que disfrutes de una experiencia de compra sin complicaciones, por eso hemos diseñado 
                                    un sistema de envíos transparente y eficiente.
                                </p>
                                <div className="flex flex-wrap gap-3">
                                    <Badge value="Cobertura Nacional" severity="success" className="" size='large lg:xlarge' />
                                    <Badge value="Seguimiento en Tiempo Real" severity="info" className="" size='large lg:xlarge' />
                                    <Badge value="Envío Gratuito Disponible" severity="warning" className="" size='large lg:xlarge' />
                                </div>
                            </div>
                            <div className="col-12 lg:col-4 text-center">
                                <img
                                    src="/imagenes/entrega-delivery.jpeg"
                                    alt="Ilustración de envíos y entregas"
                                    width="400"
                                    height="400"
                                    className="w-full h-auto"
                                    loading="lazy"
                                    decoding="async"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" mx-2 p-0">
                {/* Cobertura de envíos */}
                <div className="mb-4">
                    <Card className="p-0 m-0">
                            <h2 className="text-4xl p-0 font-bold text-primary">Cobertura de envíos</h2>
                            <div className="grid">
                                {shippingFeatures.map((feature, index) => (
                                    <div key={index} className="col-12 md:col-4">
                                        <div className="text-center">
                                            <div className="inline-flex align-items-center justify-content-center w-4rem h-4rem border-circle mb-4">
                                                <i className={`${feature.icon} text-6xl text-cyan-500`}></i>
                                            </div>
                                            <h3 className="text-xl font-semibold text-900 mb-3">{feature.title}</h3>
                                            <p className="text-600 line-height-3">{feature.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                    </Card>
                </div>

                {/* Plazos de entrega */}
                <div className="mb-6">
                    <Card>
                        <div className="p-0">
                            <h2 className="text-4xl font-bold text-primary">Plazos de entrega</h2>
                            <p className="text-lg text-700 line-height-3">
                                Los tiempos de envío pueden variar según tu ubicación y el tipo de producto:
                            </p>
                            <div className="grid">
                                {deliveryZones.map((zone, index) => (
                                    <div key={index} className="col-12 lg:col-4">
                                        <div className="surface-100 border-round p-4 h-full text-center">
                                            <div className="inline-flex align-items-center justify-content-center w-3rem h-3rem border-circle mb-4">
                                                <i className={`${zone.icon} text-6xl text-cyan-500`}></i>
                                            </div>
                                            <h3 className="text-xl font-semibold text-900 mb-3">{zone.zone}</h3>
                                            <Badge value={zone.time} severity={zone.severity} className="" size='large' />
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="mt-4 p-3 surface-100 border-round">
                                <p className="text-600 text-center m-0">
                                    <i className="pi pi-info-circle mr-2"></i>
                                    <strong>Nota:</strong> Los plazos comienzan a contarse desde la confirmación del pago
                                </p>
                            </div>
                        </div>
                    </Card>
                </div>

                {/* Costos de envío */}
                <div className="mb-6">
                    <Card>
                        <div className="p-0">
                            <h2 className="text-4xl font-bold text-primary">Costos de envío</h2>
                            <div className="grid">
                                {shippingCosts.map((cost, index) => (
                                    <div key={index} className="col-12 md:col-4">
                                        <div className="surface-100 border-round p-4 h-full text-center">
                                            <div className="inline-flex align-items-center justify-content-center w-3rem h-3rem border-circle mb-4">
                                                <i className={`${cost.icon} text-6xl text-cyan-500`}></i>
                                            </div>
                                            <h3 className="text-lg font-semibold text-900 mb-3">{cost.title}</h3>
                                            <p className="text-600 line-height-3">{cost.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="mt-4 p-3 surface-100 border-round">
                                <p className="text-600 text-center m-0">
                                    <i className="pi pi-info-circle mr-2"></i>
                                    Todos los costos se muestran antes de confirmar la compra
                                </p>
                            </div>
                        </div>
                    </Card>
                </div>

                {/* Información adicional en acordeón */}
                <div className="mb-6">
                    <Card className="p-0 m-0">

                        <div className="p-0 m-0">
                            <h2 className="text-4xl font-bold text-primary">Información adicional</h2>
                            <EnviosAccordion>
                            <AccordionTab header="📦 Seguimiento de pedidos">
                                    <div className="p-4">
                                        <div className="text-center mb-4">
                                            {/* Placeholder para imagen de seguimiento */}
                                            <div className="surface-100 border-round-xl pt-2">
                                                <i className="pi pi-search text-6xl text-primary mb-3"></i>
                                                <p className="text-lg text-700">Imagen: Pantalla de seguimiento de pedido</p>
                                                <p className="text-sm text-600">Pendiente de actualización</p>
                                            </div>
                                        </div>
                                        <p className="text-lg text-700 text-centerline-height-3">
                                            Una vez que tu pedido sea despachado, recibirás un <strong>código de seguimiento</strong> 
                                            para verificar en línea el estado de envío de tu pedido.
                                        </p>
                                        <div className="flex justify-content-center">
                                            <Button label="Rastrear mi pedido" icon="pi pi-search" className="p-button-lg" />
                                        </div>
                                    </div>
                                </AccordionTab>
                                
                                <AccordionTab header="📋 Políticas de entrega">
                                    <div className="p-0">
                                        <div className="grid">
                                            <div className="col-12">
                                                <div className="surface-100 border-round p-2">
                                                    <h4 className="text-lg font-semibold text-primary mb-3">Responsabilidades</h4>
                                                    <ul className="list-none p-0 m-0">
                                                        <li className="flex align-items-start mb-3">
                                                            <i className="pi pi-check-circle text-green-500 mr-3 mt-1"></i>
                                                            <span className="text-700">El cliente debe proporcionar una dirección correcta y completa</span>
                                                        </li>
                                                        <li className="flex align-items-start mb-3">
                                                            <i className="pi pi-clock text-orange-500 mr-3 mt-1"></i>
                                                            <span className="text-700">En caso de no encontrarse en el domicilio, el courier puede programar una nueva visita o dejar el paquete en un punto de recojo cercano</span>
                                                        </li>
                                                        <li className="flex align-items-start">
                                                            <i className="pi pi-refresh text-blue-500 mr-3 mt-1"></i>
                                                            <span className="text-700">Si un pedido no puede ser entregado por causas ajenas a la empresa, se coordinará con el cliente para la reprogramación, es posible que el courier incremente sus costos si la entrega es fallida en más de una ocasión.</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </AccordionTab>
                                
                                <AccordionTab header="🎄 Envíos en fechas especiales">
                                    <div className="p-0">
                                        <div className="text-center mb-0">
                                            <i className="pi pi-calendar text-6xl text-orange-500 mb-3"></i>
                                            <h3 className="text-xl font-semibold text-primary">Temporadas de alta demanda</h3>
                                        </div>
                                        <div className="surface-100 border-round p-4 mb-4">
                                            <p className="text-700 line-height-3 mb-4">
                                                Durante campañas como <strong>Campañas de liquidación</strong>, <strong>Cyber Days</strong>, <strong>Fiestas Patrias</strong> o <strong>Navidad</strong>, 
                                                los tiempos de entrega pueden extenderse debido a la alta demanda.
                                            </p>
                                            <div className="flex flex-wrap gap-2 justify-content-center mb-4">
                                                <Badge value="Cyber Days" severity="info" />
                                                <Badge value="Fiestas Patrias" severity="warning" />
                                                <Badge value="Navidad" severity="danger" />
                                            </div>
                                        </div>
                                        <div className="p-3 bg-primary border-round border-left-3 border-orange-500">
                                            <p className="text-700 m-0">
                                                <i className="pi pi-exclamation-triangle text-orange-500 mr-2"></i>
                                                <strong>Recomendación:</strong> Realiza tus compras con anticipación durante estas fechas
                                            </p>
                                        </div>
                                    </div>
                                </AccordionTab>
                        </EnviosAccordion>
                        </div>
                    </Card>
                </div>

                {/* Sección de contacto y soporte */}
                <div className="mb-6">
                    <Card>
                        <div className="p-6 text-center">
                            <h2 className="text-4xl font-bold text-900 mb-4">Contacto y soporte para envíos</h2>
                            <p className="text-xl text-700 mb-6 line-height-3">
                                Si tienes preguntas sobre tu envío, nuestro equipo de soporte está disponible para ayudarte
                            </p>
                            {/* Grid de acciones de contacto deshabilitado temporalmente */}
                        </div>
                    </Card>
                </div>
            </div>

            <Footer />
        </div></div>
    );
}